import JwtService from "@/core/services/JwtService";

export default {
  baseURL: localStorage.getItem("VZ_BASE_URL") || process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: JwtService.getToken(),
  },
};
